import React, { useEffect } from 'react';
import { useState, Downgraded, createState } from '@hookstate/core';
import
{
    Box, Checkbox, TextField, Typography

} from '@mui/material';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import Helper from '../../utility/helper';
import validator from 'validator';
import AllotmentCredentialItem from '../../sharedcomponents/userList/allotmentCredentialItem';
import AppConstants from '../../constants/appConstants';

const ccState = createState({
    ccEmail: '',
    bccEmail: '',
    mCInstructions: '',
    mPInstructions: '',
    mOInstructions: ''
});
const AutoApproveModule = (props) =>
{
    // console.log("props",props);
    const state = useState(ccState);
    const eventInfo = useState(null);
    const userInfo = useState(null);
    const [checked, setChecked] = React.useState(false);
    const [ccEmailErr, setCCEmailErr] = React.useState('');
    const [bccEmailErr, setBCCEmailErr] = React.useState('');
    const [isAllStarTicket, setIsAllStarTicket] = React.useState(false);
    const [credData, setCredData] = React.useState('');

    useEffect(() =>
    {
        const userEventInfo = Helper.getStorage('eventInfo');
        const guserInfo = Helper.getStorage('userInfo');
        eventInfo.set(userEventInfo);
        userInfo.set(guserInfo);
    }, []);

    useEffect(() =>
    {
        if (props.moduleInfo.moduleID == 17)
        {
            setIsAllStarTicket(true)
        }
        if (props.moduleInfo)
        {
            state.set({
                ccEmail: props.moduleInfo?.ccEmailID ? props.moduleInfo?.ccEmailID: '',
                bccEmail: props.moduleInfo?.bccEmailID ? props.moduleInfo?.bccEmailID : '',
                mCInstructions: props.moduleInfo.mcInstruction,
                mPInstructions: props.moduleInfo.mpInstruction,
                mOInstructions: props.moduleInfo.moInstruction
            });
        }
        if (props.moduleInfo.autoApprove === 1)
        {
            setChecked(true)
        }else if(props.moduleInfo.moduleID === AppConstants.EVENT_MODULES.OUTFIT){
            setChecked(true)
        } else
        {
            setChecked(false)
        }
    }, [props])

    const handleChange = (event) =>
    {
        setChecked(event.target.checked);
    };
    const isCCEmailValidate = () =>
    {
        let flag = true;
        const email =
            state.ccEmail.get() != null ? state.ccEmail.get().trim() : '';
        let selectedEmails = [];
        if (email)
        {
            selectedEmails = email.split(',');
            selectedEmails.map((item) =>
            {
                flag = item != '' ? validateEmail(item) : true;
                flag
                    ? setCCEmailErr('')
                    : setCCEmailErr('Please enter valid CC Email');
            });
        } else setCCEmailErr('');
        return flag;
    };

    const isBCCEmailValidate = () =>
    {
        let flag = true;
        const email =
            state.bccEmail.get() != null ? state.bccEmail.get().trim() : '';
        let selectedEmails = [];
        if (email)
        {
            selectedEmails = email.split(',');
            selectedEmails.map((item) =>
            {
                flag = item != '' ? validateEmail(item) : true;
                flag
                    ? setBCCEmailErr('')
                    : setBCCEmailErr('Please enter valid BCC Email');
            });
        } else setBCCEmailErr('');
        return flag;
    };
    const validateEmail = (value) =>
    {
        value = value.trim();
        if (validator.isEmail(value))
        {
            return true;
        } else return false;
    };
    const getCredetialData = (data) => {
        // console.log("data",data);
        setCredData(JSON.stringify(data))
        
    }
    const handleClick = () =>
    {
        //  console.log("credData",credData);
        //  return false
        let requestObj = {
            eventID: eventInfo.attach(Downgraded).get().eventID,
            moduleID: props.moduleInfo.moduleID,
            autoApprove: checked === true ? 1 : 0,
            ccEmailID: state.attach(Downgraded).get().ccEmail,
            bccEmailID: state.attach(Downgraded).get().bccEmail,
            mcInstruction: state.attach(Downgraded).get().mCInstructions,
            mpInstruction: state.attach(Downgraded).get().mPInstructions,
            moInstruction: state.attach(Downgraded).get().mOInstructions,
            createdBy: userInfo.get().userID,
            credRemarks: credData
        };
        console.log(requestObj)
        ApiHelper.post(APIURLConstants.EDIT_APPROVE_MODULE_INFO, requestObj)
            .then((res) =>
            {
                if (res.data > 0)
                {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Module Updated successfully',
                    });
                    props.handleCloseModule();
                    state.set({
                        ccEmail: "",
                        bccEmail: "",
                        mCInstructions: "",
                        mPInstructions: "",
                        mOInstructions: ""
                    });
                    props.handleAction();
                }
            })
            .catch((error) =>
            {
                console.log('error : ', error);
                let message = '';
                if (error.response && error.response.status === 401)
                {
                    message = 'Access denied';
                } else
                {
                    message = 'Error while Updating Module';
                }
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            })

    }


    const renderDialogContent = () =>
    {
        return (
            <>
                <Box
                    sx={{
                        flex: 1,
                        flexDirection: 'row',
                        width: '100%',
                        // display:'flex'
                    }}>

                    <Checkbox
                        checked={checked} onChange={handleChange}
                    />
                    Auto Approve

                </Box>
                <Box sx={{
                    flex: 1,
                    flexDirection: 'column',
                    width: '100%',
                    // display:'flex'
                }}>
                    <Typography
                        variant="caption"
                        sx={{
                            fontSize: '.7rem',
                            color: 'red',
                            pl: 2.5,
                        }}
                        h5>
                        {' '}
                        Separate e-mails by comma(,)
                    </Typography>

                    <TextField
                        fullWidth
                        sx={{
                            marginRight: 2,
                            marginTop: 2,
                        }}
                        value={state.ccEmail.get()}
                        size="small"
                        id="outlined-required"
                        label="CC"
                        onChange={(e) =>
                        {
                            let str = e.target.value;
                            str = str.replace(/^\s+/g, '');
                            state.ccEmail.set(str);
                        }}
                        onBlur={() => isCCEmailValidate()
                        }
                        error={ccEmailErr.length > 0 ? true : false}
                        helperText={ccEmailErr.length > 0 ? ccEmailErr : ''}
                    />
                    <Typography
                        variant="caption"
                        sx={{
                            fontSize: '.7rem',
                            color: 'red',
                            pl: 2.5,
                            marginTop: 2,
                        }}
                        h5>
                        {' '}
                        Separate e-mails by comma(,)
                    </Typography>

                    <TextField
                        fullWidth
                        sx={{
                            marginRight: 2,
                            marginTop: 2,
                        }}
                        value={state.bccEmail.get()}
                        size="small"
                        id="outlined-required"
                        label="BCC"
                        onChange={(e) =>
                        {
                            state.bccEmail.set(e.target.value);
                        }}
                        onBlur={() => isBCCEmailValidate()}
                        error={bccEmailErr.length > 0 ? true : false}
                        helperText={
                            bccEmailErr.length > 0 ? bccEmailErr : ''
                        }
                    />
                </Box>
               {props.moduleInfo.moduleID === AppConstants.EVENT_MODULES.CREDENTIAL && <Box sx={{
                    flex: 1,
                    flexDirection: 'column',
                    width: '100%',
                    marginTop: 2
                    // display:'flex'
                }}>
                    <AllotmentCredentialItem 
                    credentailsSettingItem={getCredetialData}
                    moduleInfo={props.moduleInfo}/>
                </Box>}
                {isAllStarTicket == true ?
                    <>
                        <Box sx={{ marginTop: '10px' }}>
                            <TextField
                                fullWidth
                                multiline
                                sx={{
                                    marginRight: 2,
                                }}
                                size="small"
                                id="outlined-required"
                                label="Comp Ticket Instruction"
                                type="number"
                                value={state.mCInstructions.get()}
                                onChange={(e) =>
                                {
                                    state.mCInstructions.set(e.target.value)

                                }}
                            // error={compInsErr.length > 0 ? true : false}
                            // helperText={compInsErr.length > 0 ? compInsErr : ''}
                            />
                        </Box>
                        <Box sx={{ marginTop: '10px' }}>
                            <TextField
                                fullWidth
                                sx={{
                                    marginRight: 2,
                                }}
                                multiline
                                size="small"
                                id="outlined-required"
                                label="Purchase Ticket Instruction"
                                type="number"
                                value={state.mPInstructions.get()}
                                onChange={(e) =>
                                {
                                    state.mPInstructions.set(e.target.value)

                                }}
                            // error={payInsErr.length > 0 ? true : false}
                            // helperText={payInsErr.length > 0 ? payInsErr : ''}
                            />
                        </Box>
                        <Box sx={{ marginTop: '10px' }}>
                            <TextField
                                fullWidth
                                sx={{
                                    marginRight: 2,
                                }}
                                multiline
                                size="small"
                                id="outlined-required"
                                label="Additional Purchase Ticket Instruction"
                                type="number"
                                value={state.mOInstructions.get()}
                                onChange={(e) =>
                                {
                                    state.mOInstructions.set(e.target.value)

                                }}
                            // error={addPayInsErr.length > 0 ? true : false}
                            // helperText={addPayInsErr.length > 0 ? addPayInsErr : ''}
                            />
                        </Box>
                    </> : ""}
            </>
        );
    };
    const renderDialogActions = () =>
    {
        return (
            <ButtonContainer
                handleClick={handleClick}
                handleCancel={props.handleCloseModule}
                buttonText={'Submit'}
            />
        );
    };
    return (
        <CustomDialog
            title={props.title}
            handleClose={props.handleCloseModule}
            open={props.open}
            fullWidth={true}
            maxWidth={'sm'}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
        />
    );
};

export default AutoApproveModule;
